<script>
export default {
  methods: {
    onFilePicked(evt) {
      const tmpFile = evt.currentTarget.files[0];

      if (!tmpFile) return false;
      var reader = new FileReader();
      reader.onload = evt => {
        this.form.image = evt.target.result;
      };

      reader.readAsDataURL(tmpFile);
    }
  }
};
</script>
